"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
// ----------------------------------------------------------------------
function Drawer(theme) {
    const isLight = theme.palette.mode === 'light';
    return {
        MuiDrawer: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === 'temporary' && {
                        '& .MuiDrawer-paper': {
                            boxShadow: `-40px 40px 80px -8px ${(0, styles_1.alpha)(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.24)}`,
                        },
                    }),
                }),
            },
        },
    };
}
exports.default = Drawer;
